import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-heart-icon"
};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "currentColor",
  stroke: "none"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M15.0744 8.10493L15.0743 8.10509L9.03832 14.346L9.03831 14.346C8.83977 14.5513 8.51905 14.5513 8.32052 14.346L8.32051 14.346L2.28471 8.10523C2.28466 8.10518 2.28462 8.10513 2.28457 8.10509C0.730756 6.49708 0.818279 3.83313 2.54042 2.34249C4.01174 1.06898 6.30705 1.27576 7.70652 2.72053L7.70653 2.72054L8.32174 3.35566L8.68088 3.72642L9.04002 3.35566L9.65524 2.72054L9.65524 2.72053C11.0547 1.27579 13.3499 1.06898 14.8212 2.34241C16.5435 3.83301 16.631 6.49691 15.0744 8.10493Z",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const uikitHeartIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitHeartIcon as default
};
//# sourceMappingURL=uikit-heart-icon.vue.es.js.map
